import { useRef, useState } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import Sidebar from '../../../components/sidebar/Sidebar';
import HeaderBtn from '../../../components/headerBtn/headerBtn';
import SectionContent from '../../../components/sectionContent/sectionContent';


import VacantRoutes from "../../../pages/recruiting/vacantRoutesList/vacantRoutes";



import '../../../scss/App.scss';

const VacantroutesSection = () => {

	const [overflowedBtnsCount] = useState<number>(0);
	const [isOpenGroupBtn] = useState(false);

	const buttonsContainerRef = useRef<any>(null);
	const { claims } = useSelector((state: any) => state.user.user.data);

	const availableButtons = [
		{
			component: (
				<HeaderBtn
					content="Настройки"
					purpose="vacantRoutesSettings"
					modalTitle="Настройки"
				/>
			),
		},
		(claims.includes('admin') || claims.includes('recruiting:vacancy:edit')) && {
			component: (
				<HeaderBtn
					content='Создать вакансию'
					purpose='createVacancyVacantRoutes'
					modalTitle='Создать вакансию'
				/>
			)
		},
	];

	const filteredAvailableButtons = availableButtons.filter((btn: any) => btn);

	const displayedAvailableBtns = filteredAvailableButtons
		?.slice(-(overflowedBtnsCount as number))
		?.map((elem: any, index: number) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	const displayedHeadBtns = filteredAvailableButtons
		?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
		?.map((elem: any, index: any) => {
			return elem && <div key={index}>{elem?.component}</div>;
		});

	return (
		<div className='App'>
			<Sidebar />
			<SectionContent
				availableButtons={displayedAvailableBtns}
				buttonsContainerRef={buttonsContainerRef}
				headBlockChildren={displayedHeadBtns}
				isOpenGroupBtn={isOpenGroupBtn}
				pageName='vacancy'
				section='Набор персонала'
				title="Вакантные маршруты"
			>
				<div className='content__main'>
					<div className='btns'>
					{(claims.includes('admin') || claims.includes('recruiting:vacancy:view')) && 
						<Link to={`/recruiting/vacancy`} className='tab'>
							<div className='buttons__btn'>Вакансии</div>
						</Link>}
						{(claims.includes('admin') || claims.includes('recruiting:applicationform:view')) &&		
						<Link to={`/recruiting/applicationform`} className='tab'>
							<div className='buttons__btn'>Анкеты</div>
						</Link>
						}
						{(claims.includes('admin') || claims.includes('projects:routes:list')) && 
							<Link to={`/recruiting/vacantroutes`} className='tab'>
								<div className='buttons__btn --active'>Вакантные маршруты</div>
							</Link>}
					</div>
					<VacantRoutes />
				</div>
			</SectionContent>
		</div>
	);
};

export default VacantroutesSection;
